import poultry from './poultry.json'
import beef from './beef.json'
import pork from './pork.json'
import finfishAndShellfish from './finfishAndShellFish.json'
import dairyAndEggs from './dairyAndEggs.json'
import grainsAndPasta from './grainsAndPasta.json'
import vegetables from './vegetables.json'
import legumesAndLegumeProducts from './legumesAndLegumeProducts.json'
import fruitsAndJuices from './fruitsAndJuices.json'
import nutAndSeedProducts from './nutAndSeedProducts.json'
import fatsAndOils from './fatsAndOils.json'
import bakedProducts from './bakedProducts.json'
import saucesAndSoups from './saucesAndSoups.json'
import spicesAndHerbs from './spicesAndHerbs.json'
import sweetsAndSnacks from './sweetsAndSnacks.json'
import beverages from './beverages.json'

const foods = [
  ...poultry,
  ...beef,
  ...pork,
  ...finfishAndShellfish,
  ...dairyAndEggs,
  ...grainsAndPasta,
  ...vegetables,
  ...legumesAndLegumeProducts,
  ...fruitsAndJuices,
  ...nutAndSeedProducts,
  ...fatsAndOils,
  ...bakedProducts,
  ...saucesAndSoups,
  ...spicesAndHerbs,
  ...sweetsAndSnacks,
  ...beverages,
]

export default foods
